module.exports = __webpack_public_path__ + "img/Noel.50a326f.jpg";